import { Flex, Box, Text, IconButton } from '@chakra-ui/react'
import { FC, useEffect, useState, createContext } from 'react'
import { RiCloseLine, RiFilterLine } from 'react-icons/ri'

import type {
  ILayoutToolsProps,
  LayoutToolsContextProps
} from '@base/@types/components/Layout/Tools'

import LayoutToolsActions from './Actions'
import LayoutToolsHeader from './Header'
import LayoutToolsSearcher from './Searcher'
import LayoutHeaderToggler from './Toggler'

const LayoutTools: FC<ILayoutToolsProps> = ({
  title: defaultTitle,
  message,
  filters,
  actions,
  query,
  isDisabled,

  toggleFilters,

  onClick,
  onSearchChange,
  onTitleChange,
  disableActionsByDefault
}) => {
  const [title, setTitle] = useState(defaultTitle)

  const handleTitleEdit = (value: string) => {
    setTitle(value)

    if (onTitleChange) {
      onTitleChange(value)
    }
  }

  useEffect(() => {
    setTitle(defaultTitle)
  }, [defaultTitle])

  return (
    <LayoutToolsContext.Provider
      value={{
        title,
        actions,
        isDisabled
      }}
    >
      <Flex
        pos="relative"
        h="72px"
        borderBottom="solid 1px"
        borderColor="gray.200"
        px={4}
        alignItems="center"
        justifyContent="flex-start"
      >
        {toggleFilters && (
          <IconButton
            aria-label="Toggle dos Filtros"
            icon={filters ? <RiCloseLine /> : <RiFilterLine />}
            colorScheme="green"
            size="sm"
            ml={filters ? -3 : 0}
            isRound
            mr={4}
            onClick={toggleFilters}
          />
        )}

        <Box mr="auto">
          <LayoutToolsHeader
            title={title}
            onChange={handleTitleEdit}
            isEditable={!!onTitleChange}
            isDisabled={isDisabled}
          />
          <Flex alignItems="center" pt="2px">
            {actions && actions.length > 0 && (
              <LayoutToolsActions
                onClick={onClick}
                disableActionsByDefault={disableActionsByDefault}
              />
            )}
            {message && (
              <Text
                ml={2}
                cursor="pointer"
                fontSize="xs"
                textDecoration="underline"
              >
                {message}
              </Text>
            )}
          </Flex>
        </Box>
        <Flex alignItems="center">
          {onSearchChange && (
            <LayoutToolsSearcher onChange={onSearchChange} query={query} />
          )}
          <LayoutHeaderToggler />
        </Flex>
      </Flex>
    </LayoutToolsContext.Provider>
  )
}

export default LayoutTools
export const LayoutToolsContext = createContext<LayoutToolsContextProps>(
  {} as LayoutToolsContextProps
)
